import { privateChatOpened } from 'features/chat/chatSlice';
import { readPrivateChatSaga } from 'features/chat/sagas/readPrivateChatSaga';
import { call, put, select } from 'redux-saga/effects';
import { SidePanelType } from 'features/side-panels/types';
import { selectSidePanel, sidePanelOpened } from 'features/side-panels/sidePanelsSlice';

export function* onPrivateChatOpenedSaga(action: ReturnType<typeof privateChatOpened>) {
  const activePanel: SidePanelType = yield select(selectSidePanel);

  if (activePanel !== 'chat') {
    yield put(sidePanelOpened('chat'));
  }

  yield call(readPrivateChatSaga, action.payload.id);
}
